import React from "react";
import * as Styles from "./styles/SelectEngine";
import * as Dropdown from "../../../../../../common-deprecated/styles/v2/toyota/globals/Dropdown";
import { getEngineName } from "../../../../utils/formatters/nameFormatters";
import { useCompareV2Selector } from "../../../../redux/store";
import useSelectEngine from "../../../../hooks/useSelectEngine";
import * as CompareEntryStyles from "../../styles/CompareEntry";
import { CompareV2Label } from "../../../../utils/labels";
import IconArrowDown from "../../../../../../common-deprecated/svg/v2/toyota/arrow-down.svg";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_SELECT_ENGINE } from "../../../../../../shared-logic/features/compare/utils/modalConstants";
import { trackCompareEngineOpen } from "../../../../utils/tracking";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

type SelectEnginePropsType = {
    index: number;
    engineSelectHeight: number;
    setEngineSelectHeight: (newHeight: number) => void;
    isPdf?: boolean;
};

const SelectEngine = (props: SelectEnginePropsType): JSX.Element => {
    const { index, engineSelectHeight, setEngineSelectHeight, isPdf } = props;
    const dispatch = useDispatch();

    const engines = useCompareV2Selector((state) => state.newCarCompare.specs[index]);
    const selectedEngine = useCompareV2Selector((state) => state.newCarCompare.selectedEngines[index]);
    const cars = useCompareV2Selector((state) => state.newCarCompare.grades);

    const { hasMultipleEngines, open, setOpen, dropDownRef } = useSelectEngine(
        engines,
        engineSelectHeight,
        setEngineSelectHeight,
    );

    return (
        <Styles.Wrapper>
            <CompareEntryStyles.Title>
                <CompareV2Label label="compareBodyTopEngine" />
            </CompareEntryStyles.Title>
            <Dropdown.Wrapper isLoading={cars[index].loading} onlyOneOption={!hasMultipleEngines}>
                <Dropdown.Title
                    isPdf={isPdf}
                    height={engineSelectHeight}
                    selected={open}
                    ref={dropDownRef}
                    showPointer={hasMultipleEngines}
                    onClick={() => {
                        if (hasMultipleEngines) {
                            trackCompareEngineOpen();
                            setOpen(!open);
                            dispatch(
                                showModal({
                                    type: MODAL_SELECT_ENGINE,
                                    index,
                                }),
                            );
                        }
                    }}
                >
                    {cars[index].loading ? (
                        <CompareV2Label label="compareBodyLoading" />
                    ) : (
                        <>
                            {getEngineName(selectedEngine)}
                            {!isPdf && hasMultipleEngines && <IconArrowDown />}
                        </>
                    )}
                </Dropdown.Title>
            </Dropdown.Wrapper>
        </Styles.Wrapper>
    );
};

export default SelectEngine;
